import { useCallback, useMemo } from 'react';

import { useApplicationConfig } from '~/data/applicationConfig';
import { PasswordSubmitMethod } from '~/scenes/PeopleModule/components/EmployeeActions/ResetPassword/PasswordSubmissionMethodForm/data';

export const usePasswordSubmitMethods = () => {
  const { applicationConfig } = useApplicationConfig();

  const { enableAlternateEmailAndSms } = useMemo(() => {
    const enableAlternateEmailAndSms =
      applicationConfig?.fComConfig?.miscellaneousConfig
        ?.fComEnableAlternateEmailSms || false;

    return {
      enableAlternateEmailAndSms,
    };
  }, [applicationConfig]);

  const getPasswordSubmitMethods = useCallback(
    (workEmail?: string) => {
      const hasWorkEmail = !!workEmail && workEmail.length > 0;

      const methodOptions: PasswordSubmitMethod[] = [];
      if (hasWorkEmail) {
        methodOptions.push(PasswordSubmitMethod.WorkEmail);
      }
      if (enableAlternateEmailAndSms) {
        methodOptions.push(PasswordSubmitMethod.SMS);
        methodOptions.push(PasswordSubmitMethod.AlternateEmail);
      }

      return {
        methodOptions,
        isMethodEnabled: (method: PasswordSubmitMethod) =>
          methodOptions.includes(method),
        defaultMethod: methodOptions[0],
        isMethodsAvailable: methodOptions.length > 0,
      };
    },
    [enableAlternateEmailAndSms],
  );

  return {
    getPasswordSubmitMethods,
  };
};
